
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function BrandStory() {
  const { ref, isVisible } = useScrollAnimation({ threshold: 0.1 });

  const petPhotos = [
    {
      url: 'https://static.readdy.ai/image/6d9cd499b3569668e27a60fbbc899b03/69091edf45126f57069ab9b916e74dd6.png',
      alt: '愛猫のスナップ写真'
    },
    {
      url: 'https://static.readdy.ai/image/6d9cd499b3569668e27a60fbbc899b03/01d0f7367a5f6019354af55ba86ad765.png',
      alt: '愛犬のスナップ写真'
    },
    {
      url: 'https://static.readdy.ai/image/6d9cd499b3569668e27a60fbbc899b03/9294a4158562a8d435dba73c48c6a73c.png',
      alt: '猫のグルーミング'
    },
    {
      url: 'https://static.readdy.ai/image/6d9cd499b3569668e27a60fbbc899b03/55788af49e2c06ab7528ee8b6eaaa2f0.png',
      alt: '子犬のスナップ'
    },
    {
      url: 'https://static.readdy.ai/image/6d9cd499b3569668e27a60fbbc899b03/a7a1a9b084303e878e7295d5ac5dc6cf.png',
      alt: '眠る猫'
    },
    {
      url: 'https://static.readdy.ai/image/6d9cd499b3569668e27a60fbbc899b03/ca4e485ec19a9fffba17be6874927110.png',
      alt: 'ブラッシングの時間'
    },
    {
      url: 'https://static.readdy.ai/image/6d9cd499b3569668e27a60fbbc899b03/fba0e4e4891d89aca0ae685bf88c936d.png',
      alt: '猫のストレッチ'
    },
    {
      url: 'https://static.readdy.ai/image/6d9cd499b3569668e27a60fbbc899b03/69ee9da65f4db8602f8c7119d06c52e1.png',
      alt: '窓辺の愛犬'
    },
    {
      url: 'https://static.readdy.ai/image/6d9cd499b3569668e27a60fbbc899b03/2ab8abb02602a10be5e25eb3cdc95d1a.png',
      alt: '遊ぶ猫'
    },
    {
      url: 'https://static.readdy.ai/image/6d9cd499b3569668e27a60fbbc899b03/dc8ebea6d802720b1c0ae8b5e3cc0933.jpeg',
      alt: 'ブラッシングを楽しむ猫'
    },
    {
      url: 'https://static.readdy.ai/image/6d9cd499b3569668e27a60fbbc899b03/1ead521159950ccba69eb85b6a5d8121.jpeg',
      alt: '安らぐ子犬'
    },
    {
      url: 'https://static.readdy.ai/image/6d9cd499b3569668e27a60fbbc899b03/511ef3c83ac428b841690cdd71697922.jpeg',
      alt: 'グルーミングされる白猫'
    }
  ];

  return (
    <section className="relative py-24 md:py-32 overflow-hidden" style={{ backgroundColor: '#f9f7f4' }}>
      {/* Paper Texture Overlay */}
      <div className="absolute inset-0 opacity-30" style={{ 
        backgroundImage: `url("data:image/svg+xml,%3Csvg width='100' height='100' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' /%3E%3C/filter%3E%3Crect width='100' height='100' filter='url(%23noise)' opacity='0.05'/%3E%3C/svg%3E")`,
        backgroundRepeat: 'repeat'
      }}></div>

      {/* Notebook Lines */}
      <div className="absolute inset-0 opacity-10">
        <div className="h-full" style={{
          backgroundImage: 'repeating-linear-gradient(transparent, transparent 31px, #C6A87B 31px, #C6A87B 32px)',
          backgroundSize: '100% 32px'
        }}></div>
      </div>

      {/* Red Margin Line */}
      <div className="absolute left-16 md:left-24 top-0 bottom-0 w-px bg-red-300 opacity-30"></div>

      <div className="relative max-w-7xl mx-auto px-6">
        <div 
          ref={ref}
          className={`transition-all duration-1000 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'
          }`}
        >
          {/* Title */}
          <div className="text-center mb-16 md:mb-20">
            <h2 className="text-3xl md:text-4xl lg:text-5xl leading-relaxed mb-4" style={{ 
              fontFamily: 'Noto Serif JP, serif', 
              fontWeight: 500, 
              color: '#705e44'
            }}>
              Deaiwo Sarang Spray<br className="md:hidden" /> 誕生のキッカケ
            </h2>
          </div>

          {/* Content Grid */}
          <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-start">
            {/* Story Text */}
            <div className="space-y-8 order-2 lg:order-1">
              <div className="space-y-6 text-base md:text-lg leading-loose" style={{ 
                fontFamily: 'Noto Serif JP, serif', 
                fontWeight: 400, 
                color: '#705e44'
              }}>
                <p>
                  猫13匹、犬2匹、うさぎ、ハムスター、インコ…。<br />
                  幼い頃から動物に囲まれて育ち、<br />
                  私にとってペットは"家族"そのものです。
                </p>

                <p>
                  毎日一緒に暮らす中で感じたのは、<br />
                  乾燥・汚れ・香りの刺激など、<br />
                  <strong className="font-medium">"人には気づけないストレス"がペットに積み重なっているのではないか</strong> ということ。<br />
                  一方で私たち飼い主も、<br />
                  ニオイや毛汚れに悩む瞬間があります。
                </p>

                <p>
                  そんな中、Deaiwoスキンケア愛用者の方々から<br />
                  「犬の足が乾燥してかわいそうで、クリームを塗ってもいいですか？」<br />
                  「ペットの皮ふにも使えますか？」<br />
                  という声をいただきました。
                </p>

                <p>
                  しかし、人とペットでは成分の相性が違い、<br />
                  中にはペットに負担となる成分もあります。<br />
                  だからこそ、ペットファーストを貫きたい。
                </p>

                <p className="text-lg md:text-xl font-medium pt-4">
                  「人の肌を整えてきた美容研究を、<br />
                  大切なペットへ活かせないか？」<br />
                  ――その想いを形にしたい、と。
                </p>

                <p>
                  Deaiwoが大切にしてきた<br />
                  <em className="not-italic font-medium">"使いかたはシンプル・成分は贅沢・香りは優しく・インテリアになじむ容器"</em><br />
                  言い換えれば、飽きがこない究極を目指す。<br />
                  ラグジュアリールーティーン。<br />
                  スキンケアライン全てに配合してきた甘草由来「グリチルレチン酸ステアリル」の優しいのにうるおい整う効果をペットにも。
                </p>

                <p>
                  ペットたちに、言葉を聞く事はできないからこそ<br />
                  たくさんのモニター様に実際に商品を使って頂きました。<br />
                  まさしく生の声を飼い主の皆様からお聞きできたのです。
                </p>

                <p className="text-lg md:text-xl font-medium pt-4">
                  こうして生まれたのが<br />
                  Deaiwoの出会い×愛情のSarang<br />
                  Deaiwo Sarang Sprayの誕生です。
                </p>
              </div>
            </div>

            {/* Pet Photos Grid */}
            <div className="order-1 lg:order-2">
              <div className="grid grid-cols-3 gap-3 md:gap-4">
                {petPhotos.map((photo, index) => (
                  <div 
                    key={index}
                    className="relative aspect-[4/5] overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 cursor-pointer group"
                    style={{
                      transform: `rotate(${index % 2 === 0 ? '-1' : '1'}deg)`,
                      backgroundColor: '#fff'
                    }}
                  >
                    <div className="absolute inset-0 p-2 md:p-3">
                      <div className="w-full h-full overflow-hidden">
                        <img
                          src={photo.url}
                          alt={photo.alt}
                          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                        />
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
